var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H9L7 9.5L5 7.5H6.5V0.5H7.5V7.5ZM2.5 5.5H1.5C0.95 5.5 0.5 5.95 0.5 6.5V7C0.5 7.555 0.95 8 1.5 8H2.5V8.5H0.5V9.5H2.5C3.055 9.5 3.5 9.055 3.5 8.5V6.5C3.5 5.95 3.055 5.5 2.5 5.5ZM2.5 7H1.5V6.5H2.5V7ZM2.5 0.5H1.5C0.95 0.5 0.5 0.95 0.5 1.5V3.5C0.5 4.055 0.95 4.5 1.5 4.5H2.5C3.055 4.5 3.5 4.055 3.5 3.5V1.5C3.5 0.95 3.055 0.5 2.5 0.5ZM2.5 3.5H1.5V1.5H2.5V3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort19);
export default __webpack_public_path__ + "static/media/sort19.5732ffc8.svg";
export { ForwardRef as ReactComponent };